import Vue from 'vue'
import { isWebAppQuery } from './web-auth-rules'

const scales = { small: 0.85, standard: 1, large: 1.15, extraLarge: 1.3 }
export const appFont = Vue.observable({ scale: 1 })

// A web settings choice also applies when history returns to an older web URL.
let webSelection = null
export function selectWebFont(value) {
  if (Object.prototype.hasOwnProperty.call(scales, value)) webSelection = value
}

// Keep the preference only for this WebView session, never in persistent storage.
export function installAppFont(router) {
  router.beforeEach((to, from, next) => {
    if (!isWebAppQuery(to.query)) webSelection = null
    else if (!from.matched.length && typeof to.query.appFontSize === 'string' && Object.prototype.hasOwnProperty.call(scales, to.query.appFontSize)) webSelection = to.query.appFontSize
    if (webSelection && isWebAppQuery(to.query) && isWebAppQuery(from.query) && to.query.appFontSize !== webSelection) {
      return next({ path: to.path, query: { ...to.query, appFontSize: webSelection }, hash: to.hash, replace: true })
    }
    if (Object.prototype.hasOwnProperty.call(to.query, 'appFontSize')) {
      const value = to.query.appFontSize
      appFont.scale = typeof value === 'string' && Object.prototype.hasOwnProperty.call(scales, value) ? scales[value] : 1
    }
    document.documentElement.classList.toggle('app-font-enlarged', appFont.scale > 1)
    document.documentElement.style.setProperty('--app-font-scale', appFont.scale)
    next()
  })
}
